import React, { useEffect, useState } from "react";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import EditDeleteIcon from "../../CustomComponents/EditDeleteIcon";
import moment from "moment";
import { DeleteConfirmModal } from "../../CustomComponents/DeleteConfirmModal";
import { ImCross } from "react-icons/im";
const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "35px",
  fontWeight: "bold",
};
const customStyles = {
  rows: {
    style: {
      minHeight: "24px", // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: "18px", // override the cell padding for head cells
      paddingRight: "8px",
      backgroundColor: "#cee0eb", // set the background color for head cells
    },
  },
};

const SubscriptionPlans = () => {
  const [subscription, setSubscription] = useState("");
  const [selectedSubscription, setSelectedSubscription] = useState("");



  const [subscriptionList, setSubscriptionList] = useState([]);

  const [AllData, setAllData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [editID, setEditID] = useState();



  const initialData = {
    plan: "",
    type: "", // Free or Paid
    amount: 0, //Offer price - applicable proce
    user: "", // Single or Multiple
    validity: "",
    listing: [],
    businessPack: [],
    offPercentage: "",
    actualPrice: 0,
  }

  const [formData, setFormData] = useState(initialData);
  const updateForm = (name, value) => {

    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  //Add plan
  const handleSubmit = async (e) => {
    e.preventDefault();

    if(!formData.plan){
      return toast.error("Plan name should not be empty")
    }
    if(!formData.type){
      return toast.error("Choose the plan type")
    }
    if(formData.type==="Paid" && formData.amount<=0){
      return toast.error("Applicable price for paid plan shound not be empty")
    }

    setisLoading(true);
    const data = {
      ...formData,
      listing: basicListingValues,
      businessPack: businessPackValues,
    };
    // return
    const res = await HttpClient.requestData("subscription", "POST", data);
    if (res && res?.status) {
      setisLoading(false);

      toast.success("Plan added successfully!");
      getSubscriptionPlans();
      setFormData(initialData)
      setBasicListingValues([])
      setBusinessPackValues([])
    } else {
      setisLoading(false);
      toast.error("Error occured!");
    }

  };

  const columns = [
    {
      name: "SL",
      selector: (row) => row.sl,
      width: "5%",
    },
    {
      name: "Plan name",
      selector: (row) => row.plan,
      width: "20%",
      wrap: true,
    },
    {
      name: "Offer",
      selector: (row) => row.offerText,
      width: "15%",
    },
    {
      name: "Price",
      selector: (row) => {
        return (
          <>
            {
              row.actualPrice ? <>
                <p style={{ textDecoration: "line-through" }}>{row.actualPrice}</p>
                <p>{row?.amount}</p>
              </> : <>
                <p>{row?.amount}</p>
              </>
            }
          </>
        )
      },
      width: "10%",
    },
    {
      name: "User(s)",
      selector: (row) => row.user,
      width: "15%",
    },
    {
      name: "Validity",
      selector: (row) => row.validity,
      width: "25%",
    },
    {
      name: "Action",
      selector: (row) => row.action,
      width: "10%",
    },
  ];

  // Get Subscriptions
  const getSubscriptions = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData("subscription", "GET", {});
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      setSubscriptionList(res?.data);
    } else {
      setisLoading(false);
    }

    // setAllData(apiData);
  };
  // get servicec
  const getServices = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData(
      "subscription/" + selectedSubscription,
      "GET",
      {}
    );
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      apiData = res?.data?.map((item, i) => ({
        sl: i + 1,
        name: item?.name,
        createdOn: moment(item?.createdOn).format("DD-MM-YYYY"),

        action: (
          <EditDeleteIcon
            onClickEdit={(e) => handleEdit(item)}
            onClickDelete={(e) => handleDelete(item?._id)}
          />
        ),
      }));
    } else {
      setisLoading(false);
    }

    setAllData(apiData);
  };

  // get data
  const getSubscriptionPlans = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData(
      "subscription",
      "GET",
      {}
    );
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      apiData = res?.data?.map((item, i) => ({
        sl: i + 1,
        plan: item?.plan,
        validity: item?.validity,
        amount: item?.amount,
        offerText: item?.offPercentage,
        actualPrice: item?.actualPrice || 0,
        user: item?.user,
        action: (
          <EditDeleteIcon
            onClickEdit={(e) => handleEdit(item)}
            onClickDelete={(e) => handleDelete(item?._id)}
          />
        ),
      }));
    } else {
      setisLoading(false);
    }

    setAllData(apiData);
  };

  //Delete part
  const handleDelete = (id) => {
    const del = async () => {
      setisLoading(true);
      const res = await HttpClient.requestData(
        "subscription/" + id,
        "DELETE"
      );
      if (res && res?.status) {
        setisLoading(false);
        toast.success("Deleted Successfully!");
        getSubscriptionPlans();
      } else {
        setisLoading(false);
        toast.error(res?.message || "Error occured!");
      }
    };

    DeleteConfirmModal(del);
  };

  //Edit
  const handleEdit = async (item) => {
    setisEdit(true);
    setEditID(item?._id)
    setFormData(
      {
        plan: item?.plan || "",
        type: item?.type || "",
        amount: item?.amount || 0,
        user: item?.user || "",
        validity: item?.validity || "",
        listing: item?.listing || [],
        businessPack: item?.businessPack || [],
        offPercentage: item?.offPercentage || "",
        actualPrice: item?.actualPrice || 0,
      }
    )
    setBasicListingValues(item?.listing || [])
    setBusinessPackValues(item?.businessPack || [])
  };
  //cancel edit
  const cancelEdit = (e) => {
    setisEdit(false);
    setFormData(initialData)
    setBasicListingValues([])
    setBusinessPackValues([])
  };

  // edit submit
  const handleEditSubmit = async (e) => {
    // console.log("valuesdd");
    e.preventDefault();
  
    if(!formData.plan){
      return toast.error("Plan name should not be empty")
    }
    if(!formData.type){
      return toast.error("Choose the plan type")
    }
    if(formData.type==="Paid" && formData.amount<=0){
      return toast.error("Applicable price for paid plan shound not be empty")
    }

    setisLoading(true);
    const data = {
      ...formData,
      listing: basicListingValues,
      businessPack: businessPackValues,
    };
    // return

    const res = await HttpClient.requestData(
      "subscription/" + editID,
      "PUT",
      data
    );
    // console.log("resCat", res)
    if (res && res?.status) {
      setisEdit(false);
      setEditID("")
      // resetFormData()
      // setPromoCode("");
      // setSubscription("");
      setisLoading(false);
      toast.success("Updated Successfully!");
      getSubscriptionPlans();
      setFormData(initialData)
      setBasicListingValues([])
      setBusinessPackValues([])
    } else {
      setisLoading(false);
      
      toast.error(res?.message || "Error occured!");
    }
  };

  useEffect(() => {
    getSubscriptionPlans();
  }, []);

  // Basic Listing ///////////////
  const initialBasicListing = [];

  const [basicListingValues, setBasicListingValues] = useState(initialBasicListing);

  const handleBasicListingChange = (i, e) => {
    let newFormValues = [...basicListingValues];
    newFormValues[i] = e.target.value;
    setBasicListingValues(newFormValues);
  };


  const addBasicListing = () => {
    if (basicListingValues.length < 5000) {
      setBasicListingValues([...basicListingValues, initialBasicListing]);
    } else {
      // Swal("")
      // Swal("Error", "Not more than 5000", "error");
    }
  };

  const removeBasicListing = (i) => {
    let newFormValues = [...basicListingValues];
    newFormValues.splice(i, 1);
    setBasicListingValues(newFormValues);
  };

  // //Basic Listing ///////////////

  // Business Pack ///////////////
  const initialBusinessPack = [];

  const [businessPackValues, setBusinessPackValues] = useState(initialBusinessPack);

  const handleBusinessPackChange = (i, e) => {
    let newFormValues = [...businessPackValues];
    newFormValues[i] = e.target.value;
    setBusinessPackValues(newFormValues);
  };


  const addBusinessPack = () => {
    if (businessPackValues.length < 5000) {
      setBusinessPackValues([...businessPackValues, initialBusinessPack]);
    } else {
      // Swal("")
      // Swal("Error", "Not more than 5000", "error");
    }
  };

  const removeBusinessPack = (i) => {
    let newFormValues = [...businessPackValues];
    newFormValues.splice(i, 1);
    setBusinessPackValues(newFormValues);
  };

  // //Business Pack ///////////////

  return (
    <div>
      <CustomLoader loading={isLoading} />

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <div style={headLineStyle} className="page-headline">
              Subscription Plans
            </div>
            <form>
              <div className="row">

                <div className="col-md-4 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Plan name<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter title/name"
                    value={formData.plan || ""}
                    onChange={(e) => updateForm("plan", e.target.value)}
                  />

                </div>

                <div className="col-md-2 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Type<span className="text-danger">&nbsp;*</span>
                  </label>
                  <select className="form-control"
                    onChange={(e) => updateForm("type", e.target.value)}
                  >
                    <option>-- Choose --</option>
                    <option value="Paid" selected={formData.type === "Paid" ? true : false} >Paid</option>
                    <option value="Free" selected={formData.type === "Free" ? true : false}>Free</option>
                  </select>

                </div>

                <div className="col-md-3 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Accessible user(s) information
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter short text"
                    value={formData.user || ""}
                    onChange={(e) => updateForm("user", e.target.value)}
                  />
                </div>


                <div className="col-md-3 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Validity information
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter short text"
                    value={formData.validity || ""}
                    onChange={(e) => updateForm("validity", e.target.value)}
                  />
                </div>

              </div>

              <div className="row">


                <div className="col-md-4 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Offer information
                    </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter short text"
                    value={formData.offPercentage || ""}
                    onChange={(e) => updateForm("offPercentage", e.target.value)}
                  />
                </div>


                <div className="col-md-4 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Price
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={formData.actualPrice || ""}
                    onChange={(e) => updateForm("actualPrice", e.target.value)}
                  />
                </div>

                <div className="col-md-4 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Applicable Price<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={formData.amount || ""}
                    onChange={(e) => updateForm("amount", e.target.value)}
                  />
                </div>



              </div>





              <div className="row" data-aos="fade-up">
                {/* Basic Listing */}
                <div className="col-lg-6 mt-3">
                  <label for="exampleInputEmail1">
                    Basic Listing :
                  </label>

                  {basicListingValues?.map((element, index) => (

                    <div
                      className="_form-inline" key={index} style={{ display: "flex", margin: "5px 0", width: "100%" }}>
                      <div className="form-group mb-2 mt-1" style={{ flex: "1" }}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={`Listing ${index + 1}`}
                          value={element || ""}
                          onChange={(e) => handleBasicListingChange(index, e)}
                        />
                      </div>

                      {index >= 0 ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-danger ml-1"
                          onClick={() => removeBasicListing(index)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      ) : null}
                    </div>
                  ))}
                  <div className="button-section mt-2">
                    <button
                      className="btn btn-sm btn-success"
                      type="button"
                      onClick={() => addBasicListing()}
                    >
                      <i className="fas fa-plus"></i> Listing
                    </button>

                  </div>
                </div>
                {/* //Basic Listing */}

                {/* Business Pack */}
                <div className="col-lg-6 mt-3">
                  <label for="exampleInputEmail1">
                    Business Pack :
                  </label>

                  {businessPackValues?.map((element, index) => (

                    <div
                      className="_form-inline" key={index} style={{ display: "flex", margin: "5px 0", width: "100%" }}>
                      <div className="form-group mb-2 mt-1" style={{ flex: "1" }}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={`Pack ${index + 1}`}
                          value={element || ""}
                          onChange={(e) => handleBusinessPackChange(index, e)}
                        />
                      </div>

                      {index >= 0 ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-danger ml-1"
                          onClick={() => removeBusinessPack(index)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      ) : null}
                    </div>
                  ))}
                  <div className="button-section mt-2">
                    <button
                      className="btn btn-sm btn-success"
                      type="button"
                      onClick={() => addBusinessPack()}
                    >
                      <i className="fas fa-plus"></i> Pack
                    </button>

                  </div>
                </div>
                {/* //Business Pack */}
              </div>






              {/* Button */}
              <div className="col-12 d-flex justify-content-end ">
                {isEdit ? (
                  <div className=" d-flex ">
                    <button
                      type="submit"
                      onClick={(e) => handleEditSubmit(e)}
                      className="btn btn-primaryb mt-3 btn-grad"
                    // style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                    >
                      Update
                    </button>
                    <ImCross
                      onClick={(e) => cancelEdit(e)}
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      className=" mx-3 mt-4 text-danger "
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    onClick={(e) => handleSubmit(e)}
                    className="btn btn-primaryb mt-3"
                    style={{
                      background:
                        "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))",
                      color: "#fff",
                    }}
                  >
                    Add Plan
                  </button>
                )}
              </div>
            </form>
            <div className="mt-2">
              <div style={headLineStyle} className="page-headline">
                Promo Code(s)
              </div>
              {/* <div className="col-md-6 mt-2 ">
                <label htmlFor="formGroupExampleInput">
                  Subscription
                  <span className="text-danger">&nbsp;*</span>
                </label>
                <select
                  type="text"
                  className="form-control"
                  placeholder="subscription Name Name"
                  name=""
                  value={selectedSubscription}
                  onChange={(e) => setSelectedSubscription(e.target.value)}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {subscriptionList?.map((item, i) => {
                    return (
                      <>
                        <option value={item?._id}>{item?.plan}</option>
                      </>
                    );
                  })}
                </select>
              </div> */}
              <DataTable
                columns={columns}
                data={AllData}
                pagination
                striped
                className=" rounded mt-1"
                customStyles={customStyles}
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlans;
